import { render, staticRenderFns } from "./WeiboConfig.vue?vue&type=template&id=122dfde9&scoped=true&"
import script from "./WeiboConfig.vue?vue&type=script&lang=js&"
export * from "./WeiboConfig.vue?vue&type=script&lang=js&"
import style0 from "./WeiboConfig.vue?vue&type=style&index=0&id=122dfde9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122dfde9",
  null
  
)

export default component.exports